export enum WhitePages {
    No,
    Yes,
    WhitePageOnly,
}